
import {
  LIST_ABNORMAL_DESCRIPTION_REQUEST,
  LIST_ABNORMAL_DESCRIPTION_SUCCESS,
  LIST_ABNORMAL_DESCRIPTION_FAILURE,
  CREATE_ABNORMAL_DESCRIPTION_REQUEST,
  LIST_ABNORMAL_DESCRIPTION_SUMMARY_REQUEST,
  LIST_ABNORMAL_DESCRIPTION_SUMMARY_SUCCESS,
  LIST_ABNORMAL_DESCRIPTION_SUMMARY_FAILURE,
  CREATE_ABNORMAL_DESCRIPTION_SUCCESS,
  CREATE_ABNORMAL_DESCRIPTION_FAILURE,
  DETAIL_ABNORMAL_DESCRIPTION_REQUEST,
  DETAIL_ABNORMAL_DESCRIPTION_SUCCESS,
  DETAIL_ABNORMAL_DESCRIPTION_FAILURE,
  UPDATE_ABNORMAL_DESCRIPTION_REQUEST,
  UPDATE_ABNORMAL_DESCRIPTION_SUCCESS,
  UPDATE_ABNORMAL_DESCRIPTION_FAILURE,
  DELETE_ABNORMAL_DESCRIPTION_REQUEST,
  DELETE_ABNORMAL_DESCRIPTION_SUCCESS,
  DELETE_ABNORMAL_DESCRIPTION_FAILURE,
  LIST_DETAIL_ABNORMAL_DESCRIPTION_REQUEST,
  LIST_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS,
  LIST_DETAIL_ABNORMAL_DESCRIPTION_FAILURE,
  CREATE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST,
  CREATE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS,
  CREATE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE,
  DETAIL_DETAIL_ABNORMAL_DESCRIPTION_REQUEST,
  DETAIL_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS,
  DETAIL_DETAIL_ABNORMAL_DESCRIPTION_FAILURE,
  UPDATE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST,
  UPDATE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS,
  UPDATE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE,
  DELETE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST,
  DELETE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS,
  DELETE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE,
  RESET_ABNORMAL_DESCRIPTION
} from '../../constants/abnormal-descriptions'

const initialState = {
  abnormalDescriptions: [],
  abnormalDescription: {},
  abnormalDescriptionSummary: [],
  detailAbnormalDescriptions: [],
  detailAbnormalDescription: {},
  loading: false,
  error: null,
  pageable: {
    abnormalDescriptions: {},
    detailAbnormalDescriptions: {}
  }
}

const abnormalDescriptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_ABNORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_ABNORMAL_DESCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        abnormalDescriptions: action.payload,
        pageable: {
          ...state.pageable,
          abnormalDescriptions: action.pageable
        }
      }
    case LIST_ABNORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        abnormalDescriptions: []
      }
    case LIST_ABNORMAL_DESCRIPTION_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        abnormalDescriptionSummary: []
      }
    case LIST_ABNORMAL_DESCRIPTION_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        abnormalDescriptionSummary: action.payload
      }
    case LIST_ABNORMAL_DESCRIPTION_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        abnormalDescriptionSummary: []
      }
    case CREATE_ABNORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_ABNORMAL_DESCRIPTION_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        abnormalDescriptions: [...state.abnormalDescriptions, action.payload]
      }
    case CREATE_ABNORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_ABNORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_ABNORMAL_DESCRIPTION_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        abnormalDescription: action.payload
      }
    case DETAIL_ABNORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_ABNORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_ABNORMAL_DESCRIPTION_SUCCESS:
      const abnormalDescriptionPayloadUpdate = action.payload
      const abnormalDescriptionIdUpdate = abnormalDescriptionPayloadUpdate.id
      const abnormalDescriptionIndexUpdate = state.abnormalDescriptions.findIndex(abnormalDescription => abnormalDescription.id === abnormalDescriptionIdUpdate)
      const abnormalDescriptionsUpdate = [...state.abnormalDescriptions]
      abnormalDescriptionsUpdate[abnormalDescriptionIndexUpdate] = abnormalDescriptionPayloadUpdate

      return {
        ...state,
        loadingUpdate: false,
        abnormalDescriptions: abnormalDescriptionsUpdate
      }
    case UPDATE_ABNORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_ABNORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        error: null
      }
    case DELETE_ABNORMAL_DESCRIPTION_SUCCESS:
      const abnormalDescriptionIdPayloadDelete = action.payload
      const abnormalDescriptionIndexDelete = state.abnormalDescriptions.findIndex(abnormalDescription => abnormalDescription.id === abnormalDescriptionIdPayloadDelete)
      const abnormalDescriptionsDelete = [...state.abnormalDescriptions]
      abnormalDescriptionsDelete.splice(abnormalDescriptionIndexDelete, 1)

      return {
        ...state,
        loadingDelete: false,
        abnormalDescriptions: abnormalDescriptionsDelete
      }
    case DELETE_ABNORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    case LIST_DETAIL_ABNORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        detailAbnormalDescriptions: action.payload,
        pageable: {
          ...state.pageable,
          detailAbnormalDescriptions: action.pageable
        }
      }
    case LIST_DETAIL_ABNORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        detailAbnormalDescriptions: [...state.detailAbnormalDescriptions, action.payload]
      }
    case CREATE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_DETAIL_ABNORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        detailAbnormalDescription: action.payload
      }
    case DETAIL_DETAIL_ABNORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS:
      const detailAbnormalDescriptionPayloadUpdate = action.payload
      const detailAbnormalDescriptionIdUpdate = detailAbnormalDescriptionPayloadUpdate.id
      const detailAbnormalDescriptionIndexUpdate = state.detailAbnormalDescriptions.findIndex(detailAbnormalDescription => detailAbnormalDescription.id === detailAbnormalDescriptionIdUpdate)
      const detailAbnormalDescriptionsUpdate = [...state.detailAbnormalDescriptions]
      detailAbnormalDescriptionsUpdate[detailAbnormalDescriptionIndexUpdate] = detailAbnormalDescriptionPayloadUpdate

      return {
        ...state,
        loadingUpdate: false,
        detailAbnormalDescriptions: detailAbnormalDescriptionsUpdate
      }
    case UPDATE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_DETAIL_ABNORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_DETAIL_ABNORMAL_DESCRIPTION_SUCCESS:
      const detailAbnormalDescriptionIdPayloadDelete = action.payload
      const detailAbnormalDescriptionIndexDelete = state.detailAbnormalDescriptions.findIndex(detailAbnormalDescription => detailAbnormalDescription.id === detailAbnormalDescriptionIdPayloadDelete)
      const detailAbnormalDescriptionsDelete = [...state.detailAbnormalDescriptions]
      detailAbnormalDescriptionsDelete.splice(detailAbnormalDescriptionIndexDelete, 1)

      return {
        ...state,
        loadingDelete: false,
        detailAbnormalDescriptions: detailAbnormalDescriptionsDelete
      }
    case DELETE_DETAIL_ABNORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    case RESET_ABNORMAL_DESCRIPTION:
      return {
        ...state,
        abnormalDescriptions: [],
        abnormalDescription: {},
        abnormalDescriptionSummary: [],
        detailAbnormalDescriptions: [],
        detailAbnormalDescription: {},
        loading: false,
        error: null,
        pageable: {
          abnormalDescriptions: {},
          detailAbnormalDescriptions: {}
        }
      }
    default:
      return state
  }
}

export default abnormalDescriptionsReducer